/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBriquesDelegablesResponse
 */
export interface GetBriquesDelegablesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBriquesDelegablesResponse
     */
    briques: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetBriquesDelegablesResponse
     */
    estDefaut: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBriquesDelegablesResponse
     */
    briquesDisponibles: Array<string>;
}

/**
 * Check if a given object implements the GetBriquesDelegablesResponse interface.
 */
export function instanceOfGetBriquesDelegablesResponse(value: object): value is GetBriquesDelegablesResponse {
    if (!('briques' in value) || value['briques'] === undefined) return false;
    if (!('estDefaut' in value) || value['estDefaut'] === undefined) return false;
    if (!('briquesDisponibles' in value) || value['briquesDisponibles'] === undefined) return false;
    return true;
}

export function GetBriquesDelegablesResponseFromJSON(json: any): GetBriquesDelegablesResponse {
    return GetBriquesDelegablesResponseFromJSONTyped(json, false);
}

export function GetBriquesDelegablesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBriquesDelegablesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'briques': json['briques'],
        'estDefaut': json['estDefaut'],
        'briquesDisponibles': json['briquesDisponibles'],
    };
}

export function GetBriquesDelegablesResponseToJSON(json: any): GetBriquesDelegablesResponse {
    return GetBriquesDelegablesResponseToJSONTyped(json, false);
}

export function GetBriquesDelegablesResponseToJSONTyped(value?: GetBriquesDelegablesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'briques': value['briques'],
        'estDefaut': value['estDefaut'],
        'briquesDisponibles': value['briquesDisponibles'],
    };
}

